import cfg from 'cfg';
import { requestAsync } from 'redux-query';
import { STORE_KEYS } from '../constants';
import { createApiFetch } from '../actions/helpers';
import auth from '../auth';

export const fetchWidgetSpecs = template => {
    const requestConfig = createApiFetch({
        url: `${cfg.dash.api.host}/api/widgets/spec?access_token=${auth.getAccessToken()}&template=${template}`,
        key: STORE_KEYS.WIDGET_SPECS
    });
    return requestAsync(requestConfig);
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/actions/widget-specs.js
 **/